import { ContenuTemoignage } from '@components/contenu-temoignage/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const contenuTemoignageMock: Block<ContenuTemoignage> = {
  type: 'contenu-temoignage',
  data: {
    testimonialQuote: {
      text: `Nous avons choisi SoCoo’c pour le rapport qualité/prix que nous trouvons très raisonnable et nos échanges avec les équipes.`,
      author: `Marion et Donovan`,
    },
    content: `<h2>1. Comment votre premier rendez-vous s'est passé ?</h2>
<p>Avant notre rendez-vous, c'était vraiment l'inconnu pour nous puisque nous n'avions jamais rénové de maison et donc refait de cuisine. La pièce n'étant pas très grande et avec des ouvertures comme la baie vitrée, cela nous laissait peu de choix quant à l'aménagement. Lionel, notre Kitchener, a tout de suite compris ce que nous voulions et l'échange a été efficace et fluide.</p>
<h2>2. Qu'est-ce qui vous plait le plus dans votre cuisine aujourd'hui ?</h2>
<p>Nous voulions absolument un îlot central, même si la taille de la pièce ne nous permettait pas un grand îlot. Aujourd'hui nous sommes contents de notre choix, la cuisine est fonctionnelle. Ni trop grande, ni trop petite, tout est à portée de main sans pour autant encombrer le passage, ni nous gêner.</p>
<h2>3. Qu'est-ce qui vous a fait choisir SoCoo'c ?</h2>
<p>Nous avons choisi SoCoo'c pour le rapport qualité/prix que nous trouvons très raisonnable et nos échanges avec les équipes. Lionel nous a apporté des réponses à chacune de nos questions et cela même après l'achat.</p>`,
    kitchenerMessage: {
      title: `Mot du kitchener`,
      text: `<p>Marion et Donovan souhaitaient avoir une cuisine dans le style rétro avec un îlot. Comme la pièce était petite, nous avons transformé le placard en 2 armoires qui montent jusqu’au plafond pour optimiser un maximum l’espace. Comme c’était une rénovation, nous avons dû faire attention aux contraintes de plomberie de l’existant.</p>
<p>Le choix de la verrière met en valeur leur belle cuisine campagne. J’ai eu plaisir à relever le défi d’optimiser l’espace de rangement tout en gardant un maximum d’esthétisme.</p>`,
      author: `Lionel`,
    },
    storeBanner: {
      storeName: `SoCoo'c Vitroles`,
      image: imageMock,
      url: '/magasin/socooc-vitroles',
    },
    svgStickers: [
      {
        svg: '/assets/tmp/store.svg',
      },
      {
        svg: '/assets/tmp/store.svg',
      },
    ],
  },
};
